import {
  FormControl,
  InputLabel,
  MenuItem,
  Button,
  Select,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  InputAdornment,
  IconButton,
  Modal,
  Box,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import user from "../../assets/user.gif";
import DaterangePicker from "../../common/Daterangepicker";
import commonapihandler from "../../common/commonapihandler";
import { getFuelLogs, getHubName } from "../../api/api";
import formatDate from "../../common/Formatdate";
import Fueldetailstab from "./Fueldetailstab";

function createData(
  fuellogid,
  vehicleNo,
  vehicleName,
  bookingid,
  createdAt,
  filledBy,
  fuelType,
  litersFilled,
  pricePerLiter,
  amount,
  action
) {
  return {
    fuellogid,
    vehicleNo,
    vehicleName,
    bookingid,
    createdAt,
    filledBy,
    fuelType,
    litersFilled,
    pricePerLiter,
    amount,
    action,
  };
}

const Fuelmanagementdashboard = () => {
  const profile = JSON.parse(localStorage.getItem("profile"));
  const fuelTypes = JSON.parse(localStorage.getItem("catalogValues"))?.fuelType;
  const status = JSON.parse(localStorage.getItem("status"));

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [cities, setCities] = useState(null);
  const [city, setCity] = useState("");
  const [hubs, setHubs] = useState(null);
  const [hub, setHub] = useState("");
  const [fuelLists, setFuelLists] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [openTab, setOpenTab] = useState(false);
  const [totalCount, setTotalCount] = useState(0); // for total rows from backend

  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const today = new Date();
  today.setHours(23, 59, 59, 999);
  const oneMonthAgo = new Date();
  oneMonthAgo.setMonth(today.getMonth() - 1);

  const [selectionRange, setSelectionRange] = useState({
    startDate: oneMonthAgo,
    endDate: today,
    key: "selection",
  });

  const columns = [
    { id: "fuellogid", label: "Fuel Logid", minWidth: 60 },
    { id: "vehicleNo", label: "Vehicle No", minWidth: 100 },
    { id: "vehicleName", label: "Vehicle Name", minWidth: 130, align: "right" },
    { id: "bookingid", label: "Booking Id", minWidth: 60 },
    { id: "createdAt", label: "Created At", minWidth: 120, align: "right" },
    { id: "filledBy", label: "Filled By", minWidth: 150, align: "right" },
    { id: "fuelType", label: "Fuel Type", minWidth: 110, align: "right" },
    {
      id: "litersFilled",
      label: "Liters Filled",
      minWidth: 110,
      align: "right",
      format: (value) => value?.toFixed(2),
    },
    {
      id: "pricePerLiter",
      label: "Price Per Liter",
      minWidth: 140,
      align: "right",
      format: (value) => value?.toFixed(2),
    },
    {
      id: "amount",
      label: "Amount",
      minWidth: 90,
      align: "right",
      format: (value) => value?.toFixed(2),
    },
    { id: "action", label: "Action", minWidth: 90, align: "right" },
  ];

  const rows =
    fuelLists?.map((item) =>
      createData(
        item?.id,
        item?.registrationNo,
        item?.vehicleName || "/",
        item?.bookingId ? item?.bookingId : "N/A",
        formatDate(item?.createdAt),
        item?.filledBy,
        fuelTypes?.[item?.fuelType] || "Unknown",
        item?.filledQunatity,
        item?.currentFuelPrice,
        item?.amount,
        item?.billNo,
        "View"
      )
    ) || [];

  const handleViewClick = (row) => {
    setSelectedRow(row);
    setOpenTab(true);
  };

  const getCityNames = async () => {
    try {
      const response = await fetch(`${apiUrl}/api/cities/indexify`);
      const data = await response.json();
      if (data) setCities(data);
    } catch (error) {
      console.error("Error fetching City Names:", error);
    }
  };

  const handleCityChange = (event) => {
    const value = event.target.value;
    setCity(value);
    getHubNames(value);
  };

  const handleHubChange = (event) => {
    setHub(event.target.value);
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = +event.target.value;
    setRowsPerPage(newRowsPerPage);
    setPage(0);
    getFuelListApi(0, newRowsPerPage);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    getFuelListApi(newPage, rowsPerPage);
  };

  const getHubNames = async (value) => {
    const apiDetails = await getHubName(value);
    const data = await commonapihandler(apiDetails?.apiUrl, apiDetails?.method);
    setHubs(data?.entities?.rows || []);
  };

  function formatDateForApi(date) {
    const pad = (n) => (n < 10 ? "0" + n : n);
    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());

    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }

  const formatStartDate = formatDateForApi(selectionRange?.startDate);
  const formatEndDate = formatDateForApi(selectionRange?.endDate);

  const getFuelListApi = async (
    customPage = page,
    customRowsPerPage = rowsPerPage
  ) => {
    const offset = customPage * customRowsPerPage;
    // const params = new URLSearchParams({
    //   limit: customRowsPerPage,
    //   offset: offset,
    //   startDate: formatStartDate,
    //   endDate: formatEndDate,
    // });

    // if (city && hub) {
    //   params.append("cityId", city);
    //   params.append("hubId", hub);
    // }

    let query = `limit=${customRowsPerPage}&offset=${offset}&startDate=${formatStartDate}&endDate=${formatEndDate}`;

    if (city && hub) {
      query += `&cityId=${city}&hubId=${hub}`;
    }

    const apiDetails = await getFuelLogs(query);
    const response = await commonapihandler(
      apiDetails?.apiUrl,
      apiDetails?.method
    );
    if (response?.statusCode === "0100") {
      setFuelLists(response?.entities?.rows);
      setTotalCount(response?.entities?.count || 0);
    }
  };

  useEffect(() => {
    getCityNames();
    getFuelListApi();
  }, []);

  function formatDateForApi(date) {
    const pad = (n) => (n < 10 ? "0" + n : n);
    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());

    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }

  const formattedStartDate = formatDateForApi(selectionRange?.startDate);
  const formattedEndDate = formatDateForApi(selectionRange?.endDate);

  const handleOpen = async () => {
    try {
      const response = await fetch(
        `${apiUrl}/api/fuellogs/get-reports?startDate=${formattedStartDate}&endDate=${formattedEndDate}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        const fileUrl = data?.entities?.Location;
        window.open(fileUrl, "_blank");
        try {
          const response = await fetch(fileUrl, {
            method: "GET",
          });

          if (!response.ok) {
            throw new Error("Failed to fetch file");
          }

          const blob = await response.blob();
          const url = window.URL.createObjectURL(blob);

          const a = document.createElement("a");
          a.href = url;
          a.download = "pettyCash.csv"; // This is the file name
          document.body.appendChild(a);
          a.click();

          a.remove();
          window.URL.revokeObjectURL(url);
        } catch (error) {
          console.error("Download error:", error);
        }
      } else {
        console.error("Unexpected API response:", data);
      }
    } catch (error) {
      console.error("Error fetching fuel report:", error);
    }
  };

  return (
    <>
      <div className="h-full backdrop-blur-sm sm:px-6 md:px-0 max-w-screen-xl">
        {!openTab ? (
          <>
            <>
              {!status && (
                <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-6 mt-4 w-full">
                  <div className="flex items-center gap-4">
                    <img
                      className="w-20 h-20 rounded-full"
                      src={user}
                      alt="User"
                    />
                    <h1 className="text-xl sm:text-2xl font-bold break-words">
                      Welcome back, {profile?.name}!
                    </h1>
                  </div>
                </div>
              )}

              {/* Filters + Actions */}
              <div className="w-full md:flex justify-between flex-wrap gap-4 items-end mt-4 mb-6">
                <div className="md:flex gap-4">
                  {/* Date range picker */}
                  <div className="min-w-[200px]">
                    <DaterangePicker
                      selectionRange={selectionRange}
                      setSelectionRange={setSelectionRange}
                      style={() => {}}
                    />
                  </div>

                  {/* City select */}
                  <div className="min-w-[180px]">
                    <FormControl fullWidth size="small">
                      <InputLabel id="city-select-label">City</InputLabel>
                      <Select
                        labelId="city-select-label"
                        id="city-select"
                        value={city}
                        label="City"
                        onChange={handleCityChange}
                      >
                        {cities &&
                          Object.entries(cities).map(([key, value]) => (
                            <MenuItem key={key} value={key}>
                              {value}
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                  </div>

                  {/* Hub select */}
                  <div className="min-w-[180px]">
                    <FormControl fullWidth size="small">
                      <InputLabel id="hub-select-label">Hub</InputLabel>
                      <Select
                        labelId="hub-select-label"
                        id="hub-select"
                        value={hub}
                        label="Hub"
                        onChange={handleHubChange}
                      >
                        {hubs?.length ? (
                          hubs.map((item, index) => (
                            <MenuItem key={index} value={item?.id}>
                              {item?.hubName}
                            </MenuItem>
                          ))
                        ) : (
                          <MenuItem value="">
                            <em>Select City First</em>
                          </MenuItem>
                        )}
                      </Select>
                    </FormControl>
                  </div>
                </div>

                {/* Search & Reset buttons */}
                <div className="flex gap-2">
                  <button
                    onClick={() => {
                      setPage(0);
                      getFuelListApi(0);
                    }}
                    className="bg-blue-600 text-white px-6 py-2 rounded-full shadow-md hover:bg-blue-700 transition"
                  >
                    Search
                  </button>
                  <button
                    onClick={() => {
                      setCity(null);
                      setHub(null);
                      setSelectionRange({
                        startDate: oneMonthAgo,
                        endDate: today,
                        key: "selection",
                      });
                    }}
                    className="bg-red-400 text-white px-6 py-2 rounded-full shadow-md hover:bg-gray-500 transition"
                  >
                    Reset
                  </button>
                </div>
              </div>

              {/* Fuel type boxes */}
              {/* {!status && (
                <>
                  <div className="grid grid-cols-1 md:grid-cols-5 gap-4 mb-6">
                    <div className="w-48 sm:w-48 bg-white rounded-lg shadow-lg border-2 text-center p-4 mb-6 text-[#10B981]">
                      <h5 className="font-bold mt-2">Petrol</h5>
                    </div>
                    <div className="w-48 sm:w-48 bg-white rounded-lg shadow-lg border-2 text-center p-4 mb-6 text-[#EF4444]">
                      <h5 className="font-bold mt-2">Diesel</h5>
                    </div>
                    <div className="w-48 sm:w-48 bg-white rounded-lg shadow-lg border-2 text-center p-4 mb-6 text-[#3B82F6]">
                      <h5 className="font-bold mt-2">CNG</h5>
                    </div>
                    <div className="w-48 sm:w-48 bg-white rounded-lg shadow-lg border-2 text-center p-4 mb-6 text-[#F59E0B]">
                      <h5 className="font-bold mt-2">Propane</h5>
                    </div>
                    <div className="w-48 sm:w-48 bg-white rounded-lg shadow-lg border-2 text-center p-4 mb-6 text-[#8B5CF6]">
                      <h5 className="font-bold mt-2">Total Count</h5>
                    </div>
                  </div>
                </>
              )} */}
            </>

            <div className="flex justify-between mt-4">
              <h1 className="text-2xl font-bold my-2">Fuel Lists</h1>
              {/* <div className="min-w-[180px] mt-4 flex gap-4">
              <TextField
                fullWidth
                variant="outlined"
                placeholder="Search by Fuel Type"
                onChange={(event) => {
                  handleInputSearch(event);
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={() => handleSearch()}>
                        <SearchIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </div> */}
              {!status && (
                <div title="Download Fuel Report" className="flex gap-3">
                  <button
                    onClick={handleOpen}
                    className="flex shadow-xl items-center gap-2 bg-white text-teal-900 font-semibold py-2 px-4 rounded-full"
                  >
                    <svg
                      className="w-6 h-6"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5 5 5-5M12 4v12"
                      ></path>
                    </svg>
                  </button>
                </div>
              )}
            </div>

            <div className="overflow-y-hidden hide-scrollbar w-full">
              <Paper
                sx={{
                  width: "100%",
                  overflow: "hidden",
                  marginTop: 4,
                  boxShadow: 6,
                  borderRadius: 2,
                  // padding: 2,
                }}
              >
                <TableContainer
                  sx={{
                    overflowX: "auto",
                    overflowY: "100%",
                  }}
                >
                  <Table aria-label="sticky table" stickyHeader>
                    <TableHead>
                      <TableRow>
                        {columns.map((column) => (
                          <TableCell
                            sx={{
                              // border: "1px solid #e0e0e0",
                              // backgroundColor: "#f5f5f5",
                              display: {
                                xs: column.hideOnMobile ? "none" : "table-cell",
                                sm: "table-cell",
                              },
                            }}
                            style={{ minWidth: column.minWidth }}
                            key={column.id}
                            align={column.align || "left"}
                          >
                            {column.label}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {rows.map((row, idx) => (
                        <TableRow hover key={idx}>
                          {columns.map((column) => {
                            const value = row[column.id];
                            return (
                              <TableCell
                                className="cursor-pointer"
                                // onClick={() => handleViewClick(row)}
                                key={column.id}
                                align={column.align}
                              >
                                {column.id === "action" ? (
                                  <Button
                                    size="small"
                                    variant="contained"
                                    onClick={() => handleViewClick(row)}
                                  >
                                    View
                                  </Button>
                                ) : column.format &&
                                  typeof value === "number" ? (
                                  column.format(value)
                                ) : (
                                  value || "-"
                                )}
                              </TableCell>
                            );
                          })}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
                <TablePagination
                  rowsPerPageOptions={[10, 20, 30]}
                  component="div"
                  count={totalCount}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  sx={{
                    ".MuiTablePagination-toolbar": {
                      flexDirection: { xs: "column", sm: "row" },
                      alignItems: { xs: "flex-start", sm: "center" },
                    },
                  }}
                />
              </Paper>
            </div>
          </>
        ) : (
          <>
            <Fueldetailstab
              getFuelListApi={getFuelListApi}
              openTab={openTab}
              selectedRow={selectedRow}
              setSelectedRow={setSelectedRow}
              setOpenTab={setOpenTab}
            />
          </>
        )}
      </div>
    </>
  );
};

export default Fuelmanagementdashboard;
